import { useContext, useSyncExternalStore } from 'react';
import { useSelector } from 'react-redux';
import CartPricingContext from '../contexts/CartPricingContext';
import CheckoutContext from './CheckoutContext';
import { cartContainsAnyFreeTrialBundle, cartContainsUltra } from './cart';
import { giftableTrackers, hardwareFirstGiftingFlagOn } from './hardwareFirstGiftCart';
import { latestCartPricing, serverCartPricing, subscribeToCartPricing } from './pricing';
import * as types from '../types';

export default function useHardwareFirstGiftingOffered(): boolean {
  return useHardwareFirstGiftingOfferedForCart(useContext(CheckoutContext).cart);
}

/** for the store cart outside a CheckoutContextProvider, e.g. the app-root currency sync */
export function useHardwareFirstGiftingOfferedForCart(cart: types.Cart): boolean {
  const flagOn = hardwareFirstGiftingFlagOn();
  const products = useSelector((state: types.AppState) => state.config.products);
  const latest = useSyncExternalStore(subscribeToCartPricing, latestCartPricing, serverCartPricing);
  const pricing = useContext(CartPricingContext)?.pricing ?? latest;

  if (!flagOn || !pricing?.hardwareFirstGiftingAvailable) {
    return false;
  }

  return !cartContainsAnyFreeTrialBundle(cart, products) && !cartContainsUltra(cart, products);
}

/** whether the cart can be sent as a gift: gifting is offered and the cart has a tracker to gift */
export function useHardwareFirstGiftableCart(cart: types.Cart): boolean {
  const offered = useHardwareFirstGiftingOfferedForCart(cart);
  const products = useSelector((state: types.AppState) => state.config.products);
  return offered && giftableTrackers(cart, products).length > 0;
}
